module.exports = __webpack_public_path__ + "static/media/jamie-sparker-audition-tapes2.64beb0b3.png";